import { render, staticRenderFns } from "./TemplateDesigner.vue?vue&type=template&id=9a0b1b6a&scoped=true"
import script from "./TemplateDesigner.vue?vue&type=script&lang=js"
export * from "./TemplateDesigner.vue?vue&type=script&lang=js"
import style0 from "./TemplateDesigner.vue?vue&type=style&index=0&id=9a0b1b6a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a0b1b6a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9a0b1b6a')) {
      api.createRecord('9a0b1b6a', component.options)
    } else {
      api.reload('9a0b1b6a', component.options)
    }
    module.hot.accept("./TemplateDesigner.vue?vue&type=template&id=9a0b1b6a&scoped=true", function () {
      api.rerender('9a0b1b6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/templates/TemplateDesigner.vue"
export default component.exports